module.exports = __webpack_public_path__ + "img/lucky-draw-intro.3c3d377.png";